import { BrowserRouter } from 'react-router-dom';

import { Toaster } from '@/components/ui/sonner';
import { useTheme } from '@/hooks/useTheme';
import Router from '@/Router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AlertProvider from './AlertProvider';
import DialogProvider from './DialogProvider';
import UserProvider from './UserProvider';

const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST!,
  defaults: '2025-05-24',
};

const queryClient = new QueryClient();

const Providers = () => {
  const theme = useTheme();

  useEffect(() => {
    document.documentElement.className = theme;
  }, [theme]);
  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      <Toaster />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <DialogProvider>
            <AlertProvider>
              <UserProvider>
                <GoogleReCaptchaProvider reCaptchaKey='6LfqbNYrAAAAABhTqAPnXrE9bf_HBHU8wtKO-Q_Y'>
                  <Router />
                </GoogleReCaptchaProvider>
              </UserProvider>
            </AlertProvider>
          </DialogProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </PostHogProvider>
  );
};

export default Providers;
